export default __webpack_public_path__ + "static/media/heating4.05855b39.jpeg";